import { Dialog, DialogContent, Divider, Grid, Stack, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import Logo from 'ui-component/Logo';
import AuthLogin from '../auth-forms/AuthLogin';

const LoginModal = ({ open, setOpen }) => {
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth={'sm'} fullWidth>
      <DialogContent>
        <Grid container spacing={2} alignItems="center" justifyContent="center">
          <Grid item sx={{ mb: 2, mt: 5 }}>
            <Logo />
          </Grid>
          <Grid item xs={12}>
            <Grid container direction={matchDownSM ? 'column-reverse' : 'row'} alignItems="center" justifyContent="center">
              <Grid item>
                <Stack alignItems="center" justifyContent="center" spacing={1}>
                  <Typography color={theme.palette.secondary.main} gutterBottom variant={matchDownSM ? 'h3' : 'h2'}>
                    Bienvenido
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <AuthLogin />
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <Grid item container direction="column" alignItems="center" xs={12}>
              <Typography
                onClick={() => setOpen(false)}
                component={Link}
                to="/register"
                variant="subtitle1"
                sx={{ textDecoration: 'none' }}
              >
                ¿No tienes una cuenta?
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default LoginModal;
